export const SkuFulfillmentMethod = {
  REPLENISHABLE: 1,
  ORDER_ONLY: 2,
  INDIRECT: 3,
  REMOVED: 4,
  PLANNING_WINDOW: 5,
  CAP: 6
};